<form name="userForm" class="form">
    <div *ngFor="let pref of searchPrefs">
    	<div *ngIf="displayPrefs.includes(pref.name)" class="form-group row">    
	        <div class="col-xs-5 control-label"> {{pref.displayName}} </div>
	        <div class="col-xs-7">
	            <div *ngIf="pref.name != 'DISPLAY_ADDITIONAL_ICONS'">
	                <input 
	                	*ngIf="!pref.optionElementList || pref.optionElementList.length == 0" 
	                	type="text"  
	                	[(ngModel)]="pref.value"
	            		[id]="pref.name"
	            		[name]="pref.name"	                	 
	                	class="form-control" />
	                <select 
					  *ngIf="pref.optionElementList?.length" 
					  [(ngModel)]="pref.value"
		              [id]="pref.name"
		              [name]="pref.name"				  
					  class="form-control">
					  <option *ngFor="let option of pref.optionElementList" [value]="option.value">
					    {{ option.name }}
					  </option>
					</select>
	            </div>
	            <div *ngIf="pref.name == 'DISPLAY_ADDITIONAL_ICONS'">
	                <label class="control control--checkbox" style="margin: 0px;">
	                    <input 
	                    	type="checkbox" 
	                    	[(ngModel)]="pref.value"
		              		[id]="pref.name"
		             		 [name]="pref.name" />
	                    <div class="control__indicator"></div>
	                </label>
	            </div>
	        </div>
        </div>
    </div>
    <br>
   	<button 
   		type="submit" 
   		class="btn btn-primary pull-right" 
   		(click)="updatePreferences()" 
   		title="Update search preferences">
   			{{LOCALIZATION.update}}
   	</button>
</form>